export default {
  data () {
    return {
      isDisabledRoute: true
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   this.isDisabledRoute = true
  // },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      setTimeout(() => {
        vm.isDisabledRoute = false
      }, 2200)
    })
  }
}
